export const Envs = {
  BFF_WEB_URL: process.env['NX_BFF_WEB_URL'] ?? process.env['REACT_APP_HUB_API'],
  PAY_URL: process.env['NX_PAY_URL'] ?? process.env['REACT_APP_PAY_URL'],
  INVOICE_URL: process.env['NX_INVOICE_URL'] ?? process.env['REACT_APP_INVOICE_URL'],
}
